import { useQuery } from '@tanstack/react-query';
import { useDiscoveryClient } from '../api/context';
import type { Capabilities } from '../api/types';

const OFF: Capabilities = { outreach: false, presenterCheck: false };

/**
 * What the discovery server has switched on.
 *
 * Used to disable controls whose backing feature isn't configured, so it has
 * to fail SAFE: an unreachable endpoint reports everything off, which greys a
 * checkbox out rather than offering a filter that would silently not run.
 *
 * Changes only on deploy, so it's cached for the session rather than refetched
 * every time a panel mounts.
 */
export function useCapabilities(): Capabilities {
  const client = useDiscoveryClient();
  const { data } = useQuery<Capabilities>({
    queryKey: ['discovery', 'capabilities'],
    queryFn: () => client.capabilities(),
    staleTime: Infinity,
    retry: 1,
  });
  return data ?? OFF;
}
